import * as angular from 'angular';
import { CrossReferencesOpinionOption } from '../../../../../../../../../frontend/libs/shared/src/lib/types/product/crossess-refernces';
import { Features } from '../../../../../../../../../frontend/libs/shared/src/lib/types/features';
import {
  CrossOpinionEnum,
  CrossOpinionOptionKeysEnum,
} from '../../../../../../../../../frontend/libs/shared/src/lib/types/contract/contract-product-cross-reference.enums';

class AssessmentComponentCtrl {
  /*
    popoverContainer expects a string example popover-container="'body'"
  */
  static bindings = {
    featureList: '<',
    assessmentData: '<',
    popoverContainer: '@',
    voteOnClick: '&',
    addNoteOnClick: '&',
    productId: '<',
    productCrossApproveCount: '=',
    productCrossDisputeCount: '=',
    userOrgId: '<',
    sizeVersion: '@',
    notesTitle: '@',
    thumbsUpTitle: '@',
    thumbsDownTitle: '@',
    hasThumbsButtonPopover: '<',
    crossReferenceOpinionOptions: '<',
    disableButtons: '<',
  };

  assessmentData;
  popoverContainer;
  activeTab: string;
  voteOnClick;
  addNoteOnClick;
  newNote: string;
  productId: number;
  productCrossApproveCount;
  productCrossDisputeCount;
  crossCreatedByUserOrg = false;
  userOrgId: number;
  sizeVersion: string;
  notesTitle: string;
  thumbsUpTitle: string;
  thumbsDownTitle: string;
  hasThumbsButtonPopover: boolean;
  selectedOption: CrossReferencesOpinionOption;
  crossReferenceOpinionOptions: CrossReferencesOpinionOption[];
  dropdownOptions = [];
  featureList: Features;
  isSellerCross = false;

  constructor(
    private $scope,
    private $animate,
    private $element,
    private $attrs,
  ) {
    'ngInject';
  }

  $onChanges({ crossReferenceOpinionOptions, assessmentData }) {
    if (crossReferenceOpinionOptions?.currentValue?.length) {
      this.crossReferenceOpinionOptions.forEach((option, index, options) => {
        if (index > 0 && options[index - 1].opinion !== option.opinion) {
          this.dropdownOptions.push({ divider: true });
        }

        const iconClass = this.getIconClass(option);

        const menuItem = {
          text: `<span><i class="fa ${iconClass}"></i> ${option.feedback}</span>`,
          click: `$ctrl.setSelectedOption('${option.optionKey}')`,
        };

        this.dropdownOptions.push(menuItem);
      });
    }

    if (assessmentData) {
      this.isSellerCross =
        this.assessmentData.crossReferenceCreatedByOrgType === 'Seller' ||
        this.assessmentData?.crossAssessment?.createdByOrgType === 'SELLER';

      this.crossCreatedByUserOrg =
        this.userOrgId &&
        this.assessmentData?.crossAssessment?.createdByOrg?.id ===
          this.userOrgId;
    }
  }

  setSelectedOption(optionKey: string) {
    this.selectedOption = this.crossReferenceOpinionOptions?.find(
      (option) => option.optionKey === optionKey,
    );
  }

  getIconClass(option: CrossReferencesOpinionOption): string {
    let iconClass = '';

    switch (option.opinion) {
      case 'approve':
        iconClass = 'fa-thumbs-up apt-green';
        break;
      case 'dispute':
        iconClass = 'fa-thumbs-down apt-orange';
        break;
      case 'review':
        iconClass = 'fa-square apt-yellow';
        break;
      case 'no_opinion':
        iconClass = 'fa-times';
        break;
    }

    return iconClass;
  }

  getCrossProductId(product) {
    return product.productId ? product.productId : product.id;
  }

  updateVote(vote, $event, opinionKey: string, fromDropdown: boolean) {
    $event?.stopPropagation();

    if (this.assessmentData) {
      if (!opinionKey) {
        if (vote === CrossOpinionEnum.APPROVE) {
          this.setSelectedOption(CrossOpinionOptionKeysEnum.CURRENT_PRODUCT);
        } else if (vote === CrossOpinionEnum.DISPUTE) {
          this.setSelectedOption(CrossOpinionOptionKeysEnum.UNACCEPTABLE);
        } else if (vote === CrossOpinionEnum.NO_OPINION) {
          this.setSelectedOption(CrossOpinionOptionKeysEnum.NO_OPINION);
        }
      } else {
        this.setSelectedOption(opinionKey);
      }

      this.voteOnClick({
        productId: this.productId,
        crossReferenceId: this.assessmentData.crossReferenceId,
        opinionType: this.assessmentData.crossOpinion,
        vote: vote,
        toProductId: this.getCrossProductId(this.assessmentData),
        opinionOption: this.selectedOption,
        fromDropdown,
      });

      this.selectedOption = null;
      this.runAnimation();
    }
  }

  updateVoteAndNote(
    selectedOption: CrossReferencesOpinionOption,
    note: string,
  ) {
    if (note) {
      this.addNote(note);
    }

    if (selectedOption) {
      this.updateVote(
        selectedOption.opinion,
        null,
        selectedOption.optionKey,
        true,
      );
    }

    // Clear out note and switch to Notes tab.
    this.newNote = '';
    this.activeTab = 'notes';
  }

  addNote(note) {
    if (this.assessmentData) {
      this.addNoteOnClick({
        productId: this.productId,
        crossReferenceId: this.assessmentData.crossReferenceId,
        note: note,
        toProductId: this.getCrossProductId(this.assessmentData),
      });
    }
  }

  isThereComments() {
    if (this.assessmentData) {
      if (this.assessmentData.notes) {
        return this.assessmentData.notes.length > 0;
      }
    }
  }

  setActiveTab() {
    this.newNote = '';
    this.selectedOption = null;
    if (this.assessmentData) {
      if (this.assessmentData.notes.length > 0) {
        return (this.activeTab = 'notes');
      } else {
        return (this.activeTab = 'add');
      }
    }
  }

  runAnimation() {
    if (
      angular
        .element(this.$element[0].querySelector('.assessment-comment-button'))
        .hasClass('scaleUp')
    ) {
      this.$animate
        .removeClass(
          this.$element[0].querySelector('.assessment-comment-button'),
          'scaleUp',
        )
        .then(() => {
          this.$animate.addClass(
            this.$element[0].querySelector('.assessment-comment-button'),
            'scaleUp',
          );
        });
    } else {
      this.$animate.addClass(
        this.$element[0].querySelector('.assessment-comment-button'),
        'scaleUp',
      );
    }
  }

  isThereAContainer() {
    if (this.popoverContainer) {
      return this.popoverContainer;
    } else {
      return 'body';
    }
  }

  setSizeVersion() {
    if (this.sizeVersion) {
      let output = '';
      let sizeVersion = this.sizeVersion.toLowerCase();

      switch (sizeVersion) {
        case 'small':
          output = 'btn-xs';
          return output;
        case 'medium':
          output = 'btn-md';
          return output;
        case 'large':
          output = 'btn-lg';
          return output;
        default:
          return output;
      }
    }
  }
}

export const AssessmentComponent = {
  template: require('./assessment.component.html'),
  controller: AssessmentComponentCtrl,
  transclude: true,
  bindings: AssessmentComponentCtrl.bindings,
};
